// Route components load on demand (src/router/index.js). If a chunk cannot be fetched, for
// example a tab opened before a deploy asking for a file that no longer exists or a dropped
// connection, navigate to the target URL with a full page load instead of leaving the click
// dead. A session flag stops it from looping when the network is simply down.
const KEY = 'digu:chunk-reload';
const CHUNK_ERROR = /Loading (CSS )?chunk [\w-]+ failed|ChunkLoadError|Failed to fetch dynamically imported module/i;

export function installChunkRecovery(router) {
  router.onError((error, to) => {
    if (!CHUNK_ERROR.test(String(error && (error.message || error.name)))) return;
    let last = null;
    try {
      last = sessionStorage.getItem(KEY);
      sessionStorage.setItem(KEY, to.fullPath);
    } catch {
      // Storage unavailable: still try one reload.
    }
    if (last !== to.fullPath) window.location.assign(to.fullPath);
  });
  router.afterEach(() => {
    try {
      sessionStorage.removeItem(KEY);
    } catch {
      // ignore
    }
  });
}
